import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exclude-type-guide-template',
  templateUrl: './exclude-type-guide-template.component.html',
  styleUrls: ['./exclude-type-guide-template.component.scss']
})
export class ExcludeTypeGuideTemplateComponent implements OnInit {
  examples: Array<{text: string, correct: boolean}>;

  constructor() {
    this.examples = [
      {
        text: 'template.exclude-example-1',
        correct: true
      },
      {
        text: 'template.exclude-example-2',
        correct: true
      },
      {
        text: 'template.exclude-example-3',
        correct: false
      },
      {
        text: 'template.exclude-example-4',
        correct: false
      }
    ];
  }

  ngOnInit(): void {
  }

}
